import type React from "react"

import {
  surfaceColor,
  surfaceSize,
  surfaceText
} from "../../constants/surface-tokens"

export { TABULAR } from "../../constants/surface-tokens"

/**
 * Home's design tokens.
 *
 * The palette itself now lives in `constants/surface-tokens`, because the
 * bell and the notification centre have to look like the same product and a
 * copy per surface drifts. What stays here is Home's own layout vocabulary —
 * the grid, the metric order, the card style — and these aliases, which every
 * `DashboardPage/` module already imports by name.
 */
export const homeColor = surfaceColor

export const homeText = surfaceText

export const homeSize = surfaceSize

export const HOME_FONT_STACK = "Inter, Arial, sans-serif"

export const homeCardStyle: React.CSSProperties = {
  background: homeColor.surface,
  border: `1px solid ${homeColor.border}`,
  borderRadius: homeSize.cardRadius,
  boxShadow: homeSize.cardShadow
}

/**
 * Three columns once the content area can hold all of them readably, two
 * below that (charts and shortcuts drop under the snapshot), one on a tablet.
 * The thresholds are on the BODY's own width, not the viewport: the sidebar
 * takes 236px of it and a media query cannot see that.
 */
export const HOME_BODY_GRID = "home-body-grid"

/**
 * The default reading order for the metric grid, used only when a layout has
 * no saved order of its own. A saved layout keeps exactly the order it holds.
 */
export const DEFAULT_METRIC_ORDER = [
  "revenue",
  "revenue_in_window",
  "outstanding_receivables",
  "gross_margin",
  "win_rate",
  "active_projects",
  "delayed_projects",
  "pending_approvals",
  "budget_health"
] as const
